import type { VoidFunctionComponent } from 'react';
import cx from 'classnames';
import type { Revision } from '../../../../types';
import { RevisionIssueScanState } from '../../../../types';
import getCommitStatus from '../../../generic/Pill/getCommitStatus';
import { Icon, icons } from '../../../generic';
import { ICON_SIZE } from '../../../generic/Icon/icon-constants';
import styles from './CommitStatusIcon.module.less';

type Props = {
  revision: Revision;
};

/**
 * Returns a test ID string based on the provided revision issue scan state.
 */
function getStatusTestId(state: RevisionIssueScanState) {
  switch (state) {
    case RevisionIssueScanState.IssuesFound:
      return 'issues-found';
    case RevisionIssueScanState.Passing:
      return 'passing';
    case RevisionIssueScanState.NeedsConfiguration:
      return 'needs-configuration';
    default:
      return 'waiting';
  }
}

/**
 * CommitStatusIcon displays an icon representing the status of a commit.
 */
const CommitStatusIcon: VoidFunctionComponent<Props> = ({ revision }) => {
  const status = getCommitStatus(revision);
  const statusTestId = getStatusTestId(status);

  return (
    <div
      data-testid={`commit-status-icon-${statusTestId}`}
      className={cx({
        [styles.issueFound]: status === RevisionIssueScanState.IssuesFound,
        [styles.passing]: status === RevisionIssueScanState.Passing,
        [styles.needConfiguration]: status === RevisionIssueScanState.NeedsConfiguration,
      })}
    >
      <Icon icon={icons.circle} size={ICON_SIZE.SM} />
    </div>
  );
};

export default CommitStatusIcon;
